<template>
<div class="maxContainer">
  <nameLoading class="loadContainer" v-show="loadingShow"></nameLoading>
  <img class="finalImg" :src="finalImg"/>
  <div class="finalTxt"><label>长按保存图片或截图分享</label></div>
  <div v-show="loadingShow">
    <canvas id="myCanvas" width="750px" height="1334px" ref="myCanvas" crossOrigin = "Anonymous"></canvas>
    <div class="container">
      <img class="conImg" :src="conImgSrc" ref="myPic" crossOrigin = "Anonymous"/>
      <img class="userHead" :src="usericon" ref="usericon" crossOrigin = "Anonymous"/>
      <div id="myChart" style="width: 750px;height:210px;"></div>
      <img :src="lineImg" id="lineImg" ref="lineImg" crossOrigin = "Anonymous"/>
    </div>
  </div>
  <img :src="lineImg" class="lineImg2" ref="lineImg2"/>
</div>
</template>
<script>
import echarts from 'echarts/lib/echarts'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/markLine'
import 'echarts/lib/component/markPoint'
import 'echarts/lib/component/grid'
import axios from 'axios';
import nameLoading from './nameloading.vue'
export default {
  data () {
    return {
      username: '', //昵称
      conImgSrc: '',
      usericon: require('../assets/final_icon.png'),
      lifeNum: 382471,
      textOne: '',
      sentenceOne: '',
      sentenceTwo: '是我人生山丘很重要的里程碑，人生各自精彩',
      sentenceThree: "Never lose your childish enthusiasm and things will come your way.",
      lineImg: '', //折线图
      loadingShow: true,
      finalImg: ''
    }
  },
  components: {
    nameLoading
  },
  mounted () {
    let container = document.getElementsByClassName('container')[0]
    let cwidth = container.offsetWidth;
    let cheight = container.offsetHeight;
    document.getElementById('myChart').style.width = cwidth * 1.2 +'px';
    document.getElementById('myChart').style.height = cheight * 210 / 667 * 1.2  +'px';
    this.username =  this.$store.getters.getName
    // 英文句子
    let englishNum = Math.round(Math.random() * 50);
    this.sentenceThree =  this.$store.getters.getEnglishSentence[englishNum];
    // 画线
    this.drawLine()
    this.$refs.myPic.onload  = () => {
      this.getIcon().then(()=>{
        this.getVisiterNum().then(()=> {
          this.drawCanvas()
        }) 
      })
    }
    let randomNum = Math.round(Math.random() * 4);
    randomNum++;
    this.conImgSrc = require('../assets/share_bac/p'+ randomNum +'.png')
  },
  methods: {
    drawSentence (context, sentence, left, top) {
      // if(sentence.indexOf('offer') > -1){
      //   let index = sentence.indexOf('offer')
      //   sentence = sentence.slice(0, index+1) + sentence.slice(index + 5)
      //   console.log(sentence)
      //   let sentenceArray = sentence.split('')
      //   sentenceArray[2] = 'offer'
      //   console.log(sentenceArray)
      // }
      let line = sentence.length
      line = line / 16
      for(let i = 0; i < line; i++){
        let end
        if(16+16*i > sentence.length) end = sentence.length
        else end = 16+16*i
        let text = sentence.slice(0+16*i, end)
        for(let j = 0; j < text.length; j++) {
          context.fillText(text[j], left+34*j, top+44*i)
        }
      }
    },
    drawEnglish (context, sentence, left, top) {
      //自动换行
      let str = '# ' + sentence
      const max_width = 38
      let line = sentence.length
      line = line / max_width
      let pos = []
      for(let i = 0; i < line; i++){
        if(i+max_width*(i+1) < sentence.length) {
          str = str.slice(0, i+max_width*(i+1)) + '$' + str.slice(i+max_width*(i+1))
          pos.push(i+max_width*(i+1))
        }
      }
      for (let i = 0; i < pos.length; i++) {
        let  j = pos[i];
        while (!this.isCanTab(str[j-1], str[j+1])){
          str = str.slice(0, j) + '' + str.slice(j+1);
          str = str.slice(0, j-1) + '$' + str.slice(j-1);
          j--;
          if(j-1<0) break;
        }
      }
      var array = str.split("$")
      let moveHeight = 132 - 44 * array.length
      for(let i = 0; i < array.length; i++){
        context.fillText(array[i], left, top + 44*i + moveHeight)
      }
    },
    //是否可以换行
    isCanTab (preval, nexval) {
      if (/[a-z]/i.test(preval) && /[a-z]/i.test(nexval)) return 0;
      else if (preval == "'" || nexval == "'") return 0;
      else return 1;
    },
    drawCanvas () {
      let canvas = this.$refs.myCanvas
      let context = canvas.getContext('2d')
      context.drawImage(this.$refs.myPic, 0, 0, 750, 1334)
      //绘制圆形头像
      var width = 93;
      var height = 93;
      var circle = {
        x: width / 2,
        y: height / 2,
        r: width / 2
      }
      //context.clearRect(140, 137, width, height);
      //开始路径画圆,剪切处理
      context.save();
      context.beginPath();
      context.arc(circle.x + 142, circle.y + 141, circle.r, 0, Math.PI * 2)
      context.clip(); //剪切路径
      context.drawImage(this.$refs.usericon, 142, 139, 99, 99)
      // context.drawImage(this.$refs.usericon, 142, 141, 93, 93)
      //恢复状态
      context.restore();
      try{
        context.drawImage(this.$refs.lineImg, 0, 237, 750, 420)
      } catch(e) {
        context.drawImage(this.$refs.lineImg2, 0, 237, 750, 420)
      }
      //名字
      context.font = '30px arial'
      context.textAlign='center'
      context.fillText(this.username, 340, 195)
      //文字
      context.textAlign='left'
      let index = this.sentenceOne.indexOf(this.textOne)
      if(index > -1){
        let titleLength = '', titlePreLength = ''
        for(let i = 0; i < this.textOne.length; i++){
          titleLength += ' '
        }
        for(let i = 0; i < index; i++){
          titlePreLength += ' '
        }
        context.fillStyle="#d7594c"
        this.drawSentence(context, titlePreLength+this.textOne, 110, 760)
        this.sentenceOne = this.sentenceOne.slice(0,index) + titleLength +this.sentenceOne.slice(index+this.textOne.length)
      }
      context.fillStyle="#504e4a"
      this.drawSentence(context, this.sentenceOne, 110, 760)
      if(this.sentenceOne.length / 16 <= 1){
        this.drawSentence(context, this.sentenceTwo, 110, 826)
      } else{
        this.drawSentence(context, this.sentenceTwo, 110, 870)
      }
      this.drawEnglish(context, this.sentenceThree, 110, 980)
      //第几种人生
      let space = ''
      for(let i = 0; i < (this.lifeNum+'').length; i++){
        space += '  '
      }
      context.fillText('第  ' + space + '  种人生', 110, 685)
      context.textAlign='center'
      context.fillStyle="#d7594c"
      context.fillText(this.lifeNum, 203, 685)
      context.scale(0.5, 0.5)
      this.finalImg = canvas.toDataURL("image/png")
      setTimeout(() => {
        this.loadingShow = false
      },1000)
    },
    getSentence () {
      // 第一句话
      if(this.textOne === '高考'){
        this.sentenceOne = '时间是怎么样爬过了我皮肤，只有我自己最清楚'
        this.sentenceTwo = '高考是我人生的一次重要经历，分数并不决定我的一生，人生各自精彩'
        return
      }
      let allSentenceOne = this.$store.getters.getSentenceOne
      let title = this.textOne, text = ''
      for(let i = 0; i<allSentenceOne.length; i++){
        if(allSentenceOne[i].title === title){
          text = allSentenceOne[i].text
          break
        }
      }
      if(text === ''){
        this.sentenceOne = this.textOne +'对我来说和高考一样重要'
        if(this.textOne.length <= 5){
          let englishNum = Math.round(Math.random() * 9);
          this.sentenceThree =  this.$store.getters.getLongEnglish[englishNum];
        }
      }
      else {
        this.sentenceOne = text
      }
    },
    drawLine () {
      let results = this.$store.getters.getResults
      let score = [];//分数
      let text = [];//文字
      let lineNum = [];//行数
      for (let i = 0; i<results.length; i++){
        score[i] = results[i].score;
        text[i] = results[i].text;
        if(text[i].indexOf('offer') > -1 || text[i].indexOf('10w+') > -1 || text[i].indexOf('MBA') > -1){
          lineNum[i] = parseInt(text[i].length / 3);
        } else {
          lineNum[i] = parseInt(text[i].length / 3) + 1;
        }
      }
      let  isALLZh = 0, isAllEq = true // 是否所有都是正数或负数，是否都相同
      for(let i = 0; i<score.length; i++){
        if(parseInt(score[i]) > 0) isALLZh++;
        else isALLZh--;
        if(i>0) {
          if(score[i-1] != score[i]) isAllEq = false;
        }
      }
      if (isAllEq) {
        score = [0, 0, 0, 0, 0, 0, 0]
      } else if (isALLZh == 7) {
        for(let i = 0; i<score.length; i++){
          if (parseInt(score[i]) == 1) {
            score[i] = -4
          } else if (parseInt(score[i]) == 2) {
            score[i] = -2
          } else if (parseInt(score[i]) == 3) {
            score[i] = 0
          } else if (parseInt(score[i]) == 4) {
            score[i] = 2
          } else if (parseInt(score[i]) == 5) {
            score[i] = 4
          }
        }
      } else if (isALLZh == -7) {
        for(let i = 0; i<score.length; i++){
          if (parseInt(score[i]) == -1) {
            score[i] = 4
          } else if (parseInt(score[i]) == -2) {
            score[i] = 2
          } else if (parseInt(score[i]) == -3) {
            score[i] = 0
          } else if (parseInt(score[i]) == -4) {
            score[i] = -2
          } else if (parseInt(score[i]) == -5) {
            score[i] = -4
          }
        }
      }
      let max = -5, min = 5, avg = 0;//最大值，最小值和平均值
      for(let i = 0; i<score.length; i++){
        if(parseInt(score[i])>parseInt(max)) max = score[i];
        if(parseInt(score[i])<parseInt(min)) min = score[i];
        avg -= -score[i];
      }
      avg /= score.length;
      let textOffset = [];
      for(let i = 0; i<score.length; i++){
        if(score[i] > avg) textOffset[i] = 3 - (-score[i]);
        else textOffset[i] = -3 - (-score[i]);
      }
      for(let i = 1; i<score.length-1; i++){
        if(textOffset[i-1]-score[i-1] === 3 && textOffset[i]-score[i] === 3 && textOffset[i+1]-score[i+1] === 3){
          textOffset[i] = -3 - (-score[i]);
        }
        else if(textOffset[i-1]-score[i-1] === -3 && textOffset[i]-score[i] === -3 && textOffset[i+1]-score[i+1] === -3){
          textOffset[i] = 3 - (-score[i]);
        }
      }
      if(textOffset[0]-score[0] === 3 && textOffset[1]-score[1] === 3){
        textOffset[0] = -3 - (-score[0]);
      } else if(textOffset[0]-score[0] === -3 && textOffset[1]-score[1] === -3){
        textOffset[0] = 3 - (-score[0]);
      }
      if(textOffset[6]-score[6] === 3 && textOffset[5]-score[5] === 3){
        textOffset[6] = -3 - (-score[6]);
      } else if(textOffset[6]-score[6] === -3 && textOffset[5]-score[5] === -3){
        textOffset[6] = 3 - (-score[6]);
      }
      for(let i = 0; i<score.length; i++){
        if(textOffset[i]-score[i] > 0){
          if(lineNum[i] == 2){
            textOffset[i] -= (2.7 - lineNum[i])
          } else if(lineNum[i] == 1) {
            textOffset[i] -= (1.7 - lineNum[i])
          }
        } else {
          if(lineNum[i] == 2){
            textOffset[i] += (2.7 - lineNum[i])
          } else if(lineNum[i] == 1) {
            textOffset[i] += (1.7 - lineNum[i])
          }
        }
      }
      let maxIndex = score.indexOf(max);
      this.textOne = text[maxIndex];
      this.getSentence() // 修改句子
      let minIndex = score.lastIndexOf(min);
      let num = -1;
      let myChart = echarts.init(document.getElementById('myChart'))
      // 绘制图表
      let option = {
        grid: {
          top: 0,
          bottom: 0
        },
        tooltip: {},
        xAxis: {
          show: false,
          data: [1, 2, 3, 4, 5, 6, 7]
        },
        yAxis: {
          show: false,
          min: -10,
          max: 10
        },
        series: [{
          showSymbol: true,
          symbol: 'circle',//设定为实心点
          symbolSize: () => {
            num++;
            if(num == maxIndex || num == 3){
              return 16;
            }
            else{
              return 12;
            }
          },
          animation: false,
          type: 'line',
          smooth: true,
          data: score,
          lineStyle: {
            color: '#504e4a',
            width: 1.6
          },
          itemStyle: {
            normal : {
              color: (data) => {
                if(data.dataIndex == maxIndex){
                  return '#d7594c'
                } else{
                  return '#aed1b8'
                }
              },
              borderColor: '#504e4a'
            }
          },
          markPoint : {
            symbol: 'rect',
            symbolOffset: [-18,0],
            symbolSize: [80,40],
            label: {
              show: true,
              formatter: (params) => {
                if(text[params.dataIndex].indexOf('offer') > -1) {
                  let index = text[params.dataIndex].indexOf('offer')
                  return text[params.dataIndex].slice(0,index) + '\n' + text[params.dataIndex].slice(index)
                } else if(text[params.dataIndex].indexOf('10w+') > -1) {
                  let index = text[params.dataIndex].indexOf('10w+')
                  return text[params.dataIndex].slice(0,index) + '\n' + text[params.dataIndex].slice(index)
                } else if(text[params.dataIndex].indexOf('MBA') > -1) {
                  return text[params.dataIndex]
                } else if(text[params.dataIndex].indexOf('soulmate') > -1) {
                  let index = text[params.dataIndex].indexOf('soulmate')
                  return text[params.dataIndex].slice(0,index) + '\n' + 'soul\nmate'
                } else {
                  if(text[params.dataIndex].length > 3){
                    if(text[params.dataIndex].length > 6){
                      return text[params.dataIndex].slice(0,3) + '\n' + text[params.dataIndex].slice(3,6) + '\n' + text[params.dataIndex].slice(6)
                    }
                    else{
                      return text[params.dataIndex].slice(0,3) + '\n' + text[params.dataIndex].slice(3)
                    }
                  }
                  else {
                    return text[params.dataIndex]
                  }
                }
              },
              color: '#504e4a',
              align: 'left',
              fontSize: 13
            },
            data : [
              {name : '1', xAxis: 0, yAxis: textOffset[0]},
              {name : '2', xAxis: 1, yAxis: textOffset[1]},
              {name : '3', xAxis: 2, yAxis: textOffset[2]},
              {name : '4', xAxis: 3, yAxis: textOffset[3]},
              {name : '5', xAxis: 4, yAxis: textOffset[4]},
              {name : '6', xAxis: 5, yAxis: textOffset[5]},
              {name : '7', xAxis: 6, yAxis: textOffset[6]}
            ],
            itemStyle: {
              color: 'transparent'
            }
          }
        }]
      }
      myChart.setOption(option);
      this.lineImg = myChart.getDataURL({
        type: 'png',
        pixelRatio: 2
      })
    },
    getVisiterNum () {
      return new Promise( (resolve) => {
        //http://dict.youdao.com/profile/num/loginpv?key=option_lifemountain
        //http://ns014x.corp.youdao.com:7890/profile/num/loginpv?key=option_lifemountain
        axios.get('http://dict.youdao.com/profile/num/loginpv?key=option_lifemountain',{
          withCredentials: true
        }).then((res) =>{
          this.lifeNum = Number(res.data.value) + 382471
          resolve()
        }).catch((e)=>{
          //reject(e)
          resolve(e)
        })
      })
    },
    getIcon () {
      return new Promise( (resolve) => {
        axios.get('http://dict.youdao.com/login/acc/co/cq?tp=weixin-mp-dict&cf=1&product=DICT',{
          withCredentials: true
        }).then((res)=> {
          if(typeof(res.data.imageurl) !== 'undefined' && res.data.imageurl !== ''){
            this.usericon = res.data.imageurl
            let img = new Image()
            let isCompelete = false
            img.onload = () => {
              let imgInterval =  setInterval(() => {
                if(img.complete){
                  isCompelete = true
                  clearInterval(imgInterval)
                  resolve(res)
                }
              }, 200)
              setTimeout(() =>{
                if(!isCompelete){
                  clearInterval(imgInterval)
                  this.usericon = require('../assets/final_icon.png')
                  resolve(res)
                }
              }, 2000)
            }
            img.src = res.data.imageurl
          } else {
            resolve(res)
          }
        }).catch((e)=>{
          //reject(e)
          resolve(e)
        })
      })
    }
  }
}
</script>
<style scoped>
.maxContainer{
  width: 100%;
  height: 100%;
  position: relative;
  margin: 0 auto;
  font-size: 0;
  overflow: hidden;
}
.container{
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  font-size: 0;
  z-index: -50;
}
.conImg{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.userHead{
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  overflow: hidden;
}
.finalImg{
  height: 90%;
  position: relative;
  margin: 0 auto;
  display: block;
}
.finalTxt{
  width: 100%;
  text-align: center;
  height: 10%;
  font-size: 0.27rem;
  position: relative;
}
.finalTxt label{
  width: 100%;
  height: 0.3rem;
  line-height: 0.3rem;
  position: absolute;
  top: 50%;
  left: 50%;
  margin: 0 auto;
  transform: translate(-50%, -0.15rem);
}
.loadContainer{
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 200;
}
.lineImg2{
  width: 7.5rem;
  height: 4.2rem;
  position: absolute;
  top: 4rem;
  left: 0;
  z-index: -50;
}
</style>
